import type { EverestApiTyped } from './types';

import './setup';
import { everestApiRoot } from './root';

export const everest = everestApiRoot as EverestApiTyped;

/** `initiate` options for imperative, fire-once reads: always refetch and hold no cache subscription. */
export const ONE_SHOT_FETCH = { subscribe: false, forceRefetch: true } as const;
